import { TOTAL, CURRENT_YEAR } from "../constants";

const createYearsArray = ({ fromYear = 2014, t }) => {
	const result = [];
	const years = CURRENT_YEAR - fromYear;
	const startYear = CURRENT_YEAR - years;

	for (let i = 0; i <= years; i++) {
		result[i] = {
			key: i,
			content: startYear + i,
			value: startYear + i,
		};
	}

	return [
		...result.reverse(),
		{
			key: TOTAL,
			content: `${t(
				"filtersAndSelectors:period.total"
			)} ${fromYear}-${CURRENT_YEAR}`,
			value: TOTAL,
		},
	];
};

export default createYearsArray;
